import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CostLine, CostLineType } from '../common/_types/cost-line';
import { CostsLinesService } from '../common/_services/costs-lines.service';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { firstValueFrom } from 'rxjs';
import { AccordionTabOpenEvent } from 'primeng/accordion';
import { Filter, FilterOperation, HasFilter, NotFilter } from 'src/app/core/jsonapi/filter';
import moment from 'moment';
import { TopbarService } from 'src/app/core/topbar/topbar.service';

@Component({
    selector: 'app-use',
    templateUrl: './use.component.html',
    styleUrls: ['./use.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UseComponent implements OnInit {
  
  public filters: any = {
    dateFrom: moment(new Date()).startOf('month').toDate(),
    dateTo: moment(new Date()).endOf('month').toDate()
  };
  public costsLinesCases: CostLine[] = [];
  public costsLinesSms: CostLine[] = [];
  public costsLinesGoogle: CostLine[] = [];
  public costsLinesIA: CostLine[] = [];
  public costsLinesWhatsapp: CostLine[] = [];
  public costsLinesApi: CostLine[] = [];
  public costsLinesPbx: CostLine[] = [];

  public totalRecordsCases: number = 0;
  public totalRecordsSms: number = 0;
  public totalRecordsGoogle: number = 0;
  public totalRecordsIA: number = 0;
  public totalRecordsWhatsapp: number = 0;
  public totalRecordsApi: number = 0;
  public totalRecordsPbx: number = 0;

  public totalProfitCases: number = 0;
  public totalProfitSms: number = 0;
  public totalProfitGoogle: number = 0;
  public totalProfitIA: number = 0;
  public totalProfitWhatsapp: number = 0;
  public totalProfitApi: number = 0;
  public totalProfitPbx: number = 0;

  public totalActiveCases: number = 0;
  public totalCanceledCases: number = 0;
  public totalClosedCases: number = 0;

  public data: any;
  public options: any;

  public loading: boolean = false;
  private lastCaseGridEvent: any = {first: 0, rows: 25};
  private lastSmSGridEvent: any = {first: 0, rows: 25};
  private lastGoogleGridEvent: any = {first: 0, rows: 25};
  private lastIAGridEvent: any = {first: 0, rows: 25};
  private lastWhatsappGridEvent: any = {first: 0, rows: 25};
  private lastApiGridEvent: any = {first: 0, rows: 25};
  private lastPbxGridEvent: any = {first: 0, rows: 25};

  public subtotal: number = 0;
  public tax: number = 0;
  public total: number = 0;

  // Tipos de agente de IA disponibles para el bloque "IA Agentes"
  public readonly iaAgentTypes: CostLineType[] = [
    CostLineType.OpenAI_CaseResume,
    CostLineType.OpenAI_AudioTranscription
  ];

  // Etiquetas entendibles por el usuario para cada tipo de coste
  private readonly agentTypeLabels: { [key: string]: string } = {
    [CostLineType.OpenAI_CaseResume]: 'Resumen de expediente',
    [CostLineType.OpenAI_AudioTranscription]: 'Transcripción de audio'
  };

  // Opciones del filtro multiselección de tipo de agente
  public iaAgentTypeOptions = this.iaAgentTypes.map(type => ({
    label: this.agentTypeLabels[type] ?? type,
    value: type
  }));

  // Tipos de agente seleccionados en el filtro (vacío = todos)
  public selectedIaAgentTypes: CostLineType[] = [];

  getAgentTypeLabel(type: CostLineType): string {
    return this.agentTypeLabels[type] ?? type;
  }

  onIaAgentTypeChange() {
    this.lastIAGridEvent.first = 0;
    this.loadData('ia', this.lastIAGridEvent);
  }

  onIaAgentTypeClear() {
    this.selectedIaAgentTypes = [];
    this.onIaAgentTypeChange();
  }

  get totalRequests(): number {
    return this.totalRecordsCases + this.totalRecordsSms + this.totalRecordsGoogle + this.totalRecordsIA + this.totalRecordsWhatsapp + this.totalRecordsApi + this.totalRecordsPbx;
  }

  constructor(
    private costsLinesService: CostsLinesService,
    private topbarService: TopbarService
  ) { }

  ngOnInit() {
    this.getInfoTotal();
    
    this.topbarService.setWindowTitle("GUAI - Consumos");
    this.topbarService.setTitle("Consumos");
    this.topbarService.addBreadcrumb("Consumos", "/use");
  }

  async loadData(type: any, $event: any) {
      
    switch (type) {
      case 'case': this.lastCaseGridEvent = $event; break;
      case 'sms': this.lastSmSGridEvent = $event; break;
      case 'google': this.lastGoogleGridEvent = $event; break;
      case 'ia': this.lastIAGridEvent = $event; break;
      case 'whatsapp': this.lastWhatsappGridEvent = $event; break;
      case 'api': this.lastApiGridEvent = $event; break;
      case 'pbx': this.lastPbxGridEvent = $event; break;
    }

    let filters: any = {
      type: new Filter(FilterOperation.any, "type", "")
    };
    if(type == 'case'){
      filters.type.value = [ CostLineType.Case ];
    }else if(type == 'sms'){
      filters.type.value = [ CostLineType.SMS ];
    }else if(type == 'google'){
      filters.type.value = [ CostLineType.GoogleGeocodingApi ];
    }else if(type == 'ia'){
      filters.type.value = this.selectedIaAgentTypes && this.selectedIaAgentTypes.length > 0
        ? this.selectedIaAgentTypes
        : this.iaAgentTypes;
    }else if(type == 'whatsapp'){
      filters.type.value = [ CostLineType.Whatsapp ];
    }else if(type == 'api'){
      filters.type.value = [ CostLineType.Api ];
    }else if(type == 'pbx'){
      filters.type.value = [ CostLineType.PBX ];
    }

    let params: IParamsCollection = {
      page: { number: $event.first + 1, size: $event.rows },
    }

    if (this.filters.dateFrom != null && this.filters.dateFrom != "") {    
      filters.dateFrom = new Filter(FilterOperation.greaterOrEqual, "date", "", this.filters.dateFrom.toISOString());
    }

    if (this.filters.dateTo != null && this.filters.dateTo != "") {
      filters.dateTo = new Filter(FilterOperation.lessThan, "date", "", this.filters.dateTo.toISOString());
    }

    if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];

    if(type == 'case'){
      filters.case = new NotFilter(FilterOperation.equals, "case", "", null, true);
      params.include = ["case", "case.contract", "case.caseState", "business"];
    }else if(type == 'sms'){
      params.include = ["business"];
    }else if(type == 'google'){
      params.include = ["business"];
    }else if(type == 'ia'){
      params.include = ["business"];
    }else if(type == 'whatsapp'){
      params.include = ["business"];
    }else if(type == 'api'){
      params.include = ["business"];
    }else if(type == 'pbx'){
      params.include = ["business"];
    }


    //creamos filtros
    params.filter = FilterBuilder.fromObject(filters).build();

    let response = await firstValueFrom(this.costsLinesService.all(params));
    if(type == 'case'){
      this.costsLinesCases = response.data;
      this.totalRecordsCases = response.meta['total'];
    }else if(type == 'sms'){
      this.costsLinesSms = response.data;
      this.totalRecordsSms = response.meta['total'];
    }else if(type == 'google'){
      this.costsLinesGoogle = response.data;
      this.totalRecordsGoogle = response.meta['total'];
    }else if(type == 'ia'){
      this.costsLinesIA = response.data;
      this.totalRecordsIA = response.meta['total'];
    }else if(type == 'whatsapp'){
      this.costsLinesWhatsapp = response.data;
      this.totalRecordsWhatsapp = response.meta['total'];
    }else if(type == 'api'){
      this.costsLinesApi = response.data;
      this.totalRecordsApi = response.meta['total'];
    }else if(type == 'pbx'){
      this.costsLinesPbx = response.data;
      this.totalRecordsPbx = response.meta['total'];
    }
  }

  search() {
    this.lastCaseGridEvent.first = 0;
    this.getInfoTotal();
    this.loadData('case', this.lastCaseGridEvent);
    this.loadData('sms', this.lastSmSGridEvent);
    this.loadData('google', this.lastGoogleGridEvent);
    this.loadData('ia', this.lastIAGridEvent);
    this.loadData('whatsapp', this.lastWhatsappGridEvent);
    this.loadData('api', this.lastApiGridEvent);
    this.loadData('pbx', this.lastPbxGridEvent);
  }

  edit(item: any){

  }

  async getInfoTotal(){
    //funcion customizada que me devuelva los totales. 
    var params ="";
    if(this.filters != null && this.filters.dateFrom != null){
      params += (params!="" ? "&" : "") + "dateFrom=" + this.filters.dateFrom.toISOString();
    }
    if(this.filters != null && this.filters.dateTo != null){
      params += (params!="" ? "&" : "") + "dateTo=" + this.filters.dateTo.toISOString();
    }

    //let params = {dateFrom: this.filters.dateFrom.toISOString(), dateTo: this.filters.dateTo.toISOString()};
    let response = await firstValueFrom(this.costsLinesService.getProfits(params));
    this.totalProfitCases = response.totalProfitCases;
    this.totalProfitSms = response.totalProfitSms;
    this.totalProfitGoogle = response.totalProfitGoogle;
    this.totalProfitIA = response.totalProfitIA;
    this.totalProfitWhatsapp = response.totalProfitWhatsapp;
    this.totalProfitApi = response.totalProfitApi ?? 0;
    this.totalProfitPbx = response.totalProfitPbx ?? 0;
    this.totalActiveCases = response.totalActiveCases;
    this.totalCanceledCases = response.totalCanceledCases;
    this.totalClosedCases = response.totalClosedCases;

    // Calculate subtotal, tax, and total
    this.subtotal = this.totalProfitCases + this.totalProfitSms + this.totalProfitGoogle + this.totalProfitIA + this.totalProfitWhatsapp + this.totalProfitApi + this.totalProfitPbx;
    this.tax = Math.round(this.subtotal * 0.21 * 100) / 100; // Round to 2 decimal places
    this.total = this.subtotal + this.tax;

  }

  async onTabChange(event: AccordionTabOpenEvent) {
  
    if (event.index == 0) {
      //expedientes
      this.loadData('case', this.lastCaseGridEvent);
    } else if (event.index == 1) {
      //sms
      this.loadData('sms', this.lastSmSGridEvent);
    } else if (event.index == 2) {
      //google
      this.loadData('google', this.lastGoogleGridEvent);
    } else if (event.index == 3) {
      //ia
      this.loadData('ia', this.lastIAGridEvent);
    } else if (event.index == 4) {
      //api
      this.loadData('api', this.lastApiGridEvent);
    } else if (event.index == 5) {
      //centralita
      this.loadData('pbx', this.lastPbxGridEvent);
    } else if (event.index == 6) {
      //whatsapp
      this.loadData('whatsapp', this.lastWhatsappGridEvent);
    }
  }

}
